
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-black/30 border-t border-web3-blue/20 mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid gap-8 md:grid-cols-2">
          <div>
            <p className="text-white/80 mb-4">
              © 2025 <a href="https://theblockchainacademy.com" target="_blank" rel="noopener noreferrer" className="text-web3-green hover:text-web3-blue transition-colors underline">The Blockchain Academy Inc.</a> | All Rights Reserved
            </p>
            <div className="space-x-4">
              <Link to="/terms" className="text-web3-green hover:text-web3-blue transition-colors">
                Terms of Use
              </Link>
              <Link to="/privacy" className="text-web3-green hover:text-web3-blue transition-colors">
                Privacy Policy
              </Link>
            </div>
          </div>
          
          <div className="text-sm text-white/60">
            <p>
              The Bitcoin Mining Career Simulator offers a guided, gamified journey through possible career paths 
              in the mining sector. While designed to mirror real-world opportunities and challenges, it remains 
              a simulation: an educational tool, not a career guarantee. We strive to present accurate, practical 
              scenarios, but outcomes here do not predict, promise, or replace real-world performance. Explore boldly, 
              learn deeply, and use these insights wisely as part of your broader career discovery process.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
